import { r as registerInstance, h, a as Host } from './index-BntG-4Sv.js';
import { T as TranslationService } from './translation.service-FB05Sh97.js';
import '@ontotext/workbench-api';

const translateLabelCss = ":host{display:inline}";

const TranslateLabel = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.unsubscribeTranslationChanged = null;
        /**
         * Represents an array of translation parameters.
         */
        this.translationParameters = [];
    }
    connectedCallback() {
        this.unsubscribeTranslationChanged = TranslationService.onTranslate(this.labelKey, this.translationParameters, (translatedLabel) => this.translatedLabel = translatedLabel);
    }
    disconnectedCallback() {
        if (this.unsubscribeTranslationChanged) {
            this.unsubscribeTranslationChanged();
            this.unsubscribeTranslationChanged = null;
        }
    }
    render() {
        return (h(Host, { key: 'e14ed023755becfab8af466ba80b866d896037f2' }, this.translatedLabel));
    }
};
TranslateLabel.style = translateLabelCss;

export { TranslateLabel as translate_label };
